import React, { useCallback, useRef, useState } from "react";
import { HexColorPicker } from "react-colorful";
import useStyles from "./color_picker_styles";

import useClickOutside from "./use_click_outside";

export const ColorPicker = ({ color, onChange, label, disabled = false }) => {
  const classes = useStyles();
  const popover = useRef();
  const [isOpen, toggle] = useState(false);

  const close = useCallback(() => toggle(false), []);
  useClickOutside(popover, close);

  return (
    <div className={classes.picker}>
      <div className={classes.row}>
        <div>{label}</div>
        <div
          className={classes.swatch}
          style={{ backgroundColor: color }}
          onClick={disabled ? null : () => toggle(true)}
        />
      </div>

      {isOpen && (
        <div className={classes.popover} ref={popover}>
          <HexColorPicker color={color} onChange={onChange} />
        </div>
      )}
    </div>
  );
};
